import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Chip, FormControl, TextField } from '@mui/material'
import { MultipleAutocomplete } from '@carto/meridian-ds/components'

function MultipleValuesInput({ onChange }: { onChange: (event: string[]) => void }) {
  const intl = useIntl()
  const [values, setValues] = useState<string[]>([])

  const handleChange = (event, newValue) => {
    setValues(newValue)
    onChange(newValue)
  }

  return (
    <FormControl size="small">
      <MultipleAutocomplete
        freeSolo
        size="small"
        options={values}
        onChange={handleChange}
        renderTags={(value: readonly string[], getTagProps) =>
          value.map((option: string, index: number) => (
            <Chip variant="filled" size="small" color="default" label={option} {...getTagProps({ index })} />
          ))
        }
        renderInput={(params) => (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          <TextField
            {...params}
            variant="outlined"
            name="filter-text-values"
            size="small"
            label={<FormattedMessage id="analysis.columnValue.values" />}
            placeholder={intl.formatMessage({ id: 'analysis.columnValue.selectValPlaceholder' })}
            InputLabelProps={{
              shrink: true
            }}
          />
        )}
      />
    </FormControl>
  )
}

export default MultipleValuesInput
